import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const AffiliateProgramsRoutes: Routes = [
  {
    path: "affiliate-programs",
    loadComponent: () =>
      import("./affiliate-programs/affiliate-programs.component").then(
        (m) => m.AffiliateProgramsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./affiliate-programs-list/affiliate-programs-list.component").then(
            (m) => m.AffiliateProgramsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./affiliate-programs-form/affiliate-programs-form.component").then(
            (m) => m.AffiliateProgramsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./affiliate-programs-form/affiliate-programs-form.component").then(
            (m) => m.AffiliateProgramsFormComponent,
          ),
      },
      {
        path: "view/:id/partner-configuration",
        loadComponent: () =>
          import("./partner-configuration-form/partner-configuration-form.component").then(
            (m) => m.PartnerConfigurationFormComponent,
          ),
      },
      {
        path: "view/:id/partner-configuration/:partnerId",
        loadComponent: () =>
          import("./partner-configuration-form/partner-configuration-form.component").then(
            (m) => m.PartnerConfigurationFormComponent,
          ),
      },
      {
        path: "view/:affiliateProgramId/partner-configuration/:partnerId/bonus-campaign",
        loadComponent: () =>
          import("./bonus-campaign-form/bonus-campaign-form.component").then(
            (m) => m.BonusCampaignFormComponent,
          ),
      },
      {
        path: "view/:affiliateProgramId/partner-configuration/:partnerId/bonus-campaign/:id",
        loadComponent: () =>
          import("./bonus-campaign-form/bonus-campaign-form.component").then(
            (m) => m.BonusCampaignFormComponent,
          ),
      },
      {
        path: "view/:id/marketplace-configuration",
        loadComponent: () =>
          import("./marketplace-configuration-form/marketplace-configuration-form.component").then(
            (m) => m.MarketplaceConfigurationFormComponent,
          ),
      },
      {
        path: "view/:id/marketplace-configuration/:partnerId",
        loadComponent: () =>
          import("./marketplace-configuration-form/marketplace-configuration-form.component").then(
            (m) => m.MarketplaceConfigurationFormComponent,
          ),
      },
    ],
  },
];
